import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Module } from '../../../../../common/model/ModuleModel';
import { ModalData, ModalService } from '@shopping-angular-components/modal';
import { InfoMetadataModalComponent } from './info-metadata-modal.component';
import { Subscription } from 'rxjs';
import { UpaService, UpaTrackingData, UpaTrackingDataWithEventType } from 'projects/common/services/upa.service';

@Component({
  selector: 'info-metadata',
  styleUrls: ['./info-metadata.component.scss'],
  template: `
    <div class="eva-3-card">
      <eva-dropdown>
        <eva-dropdown-item
          [ngClass]=""
          (clickEvent)="handleDropdownClick()"
          [expand]="shouldShowInfo"
        >
          <span class="-eva-3-pl-lg item-label eva-3-link" label>{{
            buttonLabel
          }}</span>

          <div content class="dropdown-content">
            <!-- Info to show -->
            <div
              class="items-container -eva-3-pl-md"
              *ngFor="let key of getKeys(infoToShow)"
            >
              <div class="-eva-3-pb-xsm -eva-3-pl-lg">
                <span class="-eva-3-pr-sm eva-3-body-1 -eva-3-tc-gray-1"
                  >{{ key.charAt(0).toUpperCase() + key.slice(1) }}:</span
                >
                <span class="eva-3-body-1">{{ infoToShow[key] }}</span>
              </div>
            </div>

            <!-- Tracking info -->
            <div class="items-container -eva-3-pl-md" *ngIf="getKeys(trackingInfo).length > 0">
              <li class="" [ngClass]="{'-active': expand}">
                <span class="tracking-dropdown-heading" (click)="toggleExpandTrackingInfo()">
                  <span class="-eva-3-pr-sm eva-3-body-1 -eva-3-tc-gray-1">
                    Tracking info
                  </span>
                  <i [class]="'tracking-dropdown-icon eva-3-icon-chevron-' + (expand ? 'down' : 'up')"></i>
                </span>
                <div class="tracking-dropdown-content" *ngIf="expand">
                  <div *ngFor="let key of getKeys(trackingInfo)" class="tracking-item">
                    <span class="tracking-key -eva-3-tc-gray-1">{{ key }}:</span>
                    <div *ngFor="let subKey of getKeys(trackingInfo[key])" class="tracking-sub-item">
                      <span class="tracking-key -eva-3-tc-gray-1">{{ subKey }}:</span>
                      <span class="tracking-value">
                        <ng-container *ngIf="isObject(trackingInfo[key][subKey]); else primitiveValue">
                          <div *ngFor="let nestedKey of getKeys(trackingInfo[key][subKey])">
                            <span class="tracking-key -eva-3-tc-gray-1">{{ nestedKey }}:</span>
                            <span class="tracking-value">{{ trackingInfo[key][subKey][nestedKey] }}</span>
                          </div>
                        </ng-container>
                        <ng-template #primitiveValue>
                          {{ trackingInfo[key][subKey] }}
                        </ng-template>
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </div>

            <!-- Metabase link -->
            <a href="{{ module.metadata?.metabase_url }}" target="_blank">
              <button
                name="metabase-btn"
                class="-eva-3-ml-sm eva-3-btn -lg -link"
              >
                <em class="btn-text">Ver en metabase</em>
              </button>
            </a>

            <!-- Modal button -->
            <button
              name="info-btn"
              class="-eva-3-ml-sm eva-3-btn -lg -primary"
              (click)="handleOnModalButtonClick()"
            >
              <em class="btn-text">Ver db info</em>
            </button>

            <!-- Debug info button -->
            <button
              name="info-btn"
              class="-eva-3-ml-sm eva-3-btn -lg -primary"
              (click)="handleDebugInfoClick()"
            >
              <em class="btn-text">Debug Info</em>
            </button>
          </div>
        </eva-dropdown-item>
      </eva-dropdown>
    </div>
  `,
})
export class InfoMetadataComponent implements OnInit, OnDestroy {
  @Input() module: Module;

  shouldShowInfo = false;
  buttonLabel = 'Mostrar info';
  infoToShow: { [key: string]: any } = {};
  modalData: ModalData;
  trackingInfo: {[key: string]: UpaTrackingDataWithEventType} = {};
  debugInfo: ModalData;

  expand: boolean = false;

  private trackingSubscription: Subscription;
  
  constructor(private modalService: ModalService, private upaService: UpaService) {}

  ngOnInit(): void {
    const { ajax, unique_id, filterable, metadata } = this.module;

    this.infoToShow = {
      ajax,
      unique_id,
      filterable
    };

    this.modalData = {
      id: 'info-metadata-modal',
      contentComponent: InfoMetadataModalComponent,
      product: '',
      flow: '',
      isWebview: false,
      contentModel: {
        content: metadata?.module_configuration_from_db,
      },
      fullScreen: false,
    };

    this.debugInfo = {
      id: 'debug-info-modal',
      contentComponent: InfoMetadataModalComponent,
      product: '',
      flow: '',
      isWebview: false,
      contentModel: {
        content: metadata?.debug_info,
      },
      fullScreen: false,
    };

    this.trackingSubscription = this.upaService.trackingData$.subscribe((trackingData) => {
      if (trackingData.eventtype && this.module.unique_id === trackingData.unique_id) {
        this.trackingInfo[trackingData.eventtype] = trackingData;
      }
    });
  }

  handleDropdownClick() {
    this.shouldShowInfo = !this.shouldShowInfo;
    this.buttonLabel = this.shouldShowInfo ? 'Ocultar info' : 'Mostrar info';
  }

  handleOnModalButtonClick() {
    this.modalService.showModal(this.modalData);
  }

  handleDebugInfoClick() {
    this.modalService.showModal(this.debugInfo);
  }

  getKeys(obj: { [key: string]: any }): string[] {
    return Object.keys(obj);
  }

  public toggleExpandTrackingInfo() {
    this.expand = !this.expand;

    if (this.expand) {
      const viewTrackingData = this.upaService.getViewTrackData(this.module.unique_id);
      if (viewTrackingData) {
        this.trackingInfo["view"] = viewTrackingData;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.trackingSubscription) {
      this.trackingSubscription.unsubscribe();
    }
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }
}
